export default __webpack_public_path__ + "static/media/livesource.5497621a.png";